module.exports = __webpack_public_path__ + "assets/images/team-home-logo-placeholder.9f7a47a4c897cc9753b0ffd29863633f.png";